<!-- ToggleButton.vue -->
<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import jaJP from "@/locales/ja-JP.json";
import enUS from "@/locales/en-US.json";

type MessageSchema = typeof jaJP;

const { t } = useI18n<{
  message: MessageSchema
}, "ja-JP" | "en-US">({
  inheritLocale: true,
  messages: {
    "ja-JP": jaJP,
    "en-US": enUS,
  }
});

interface Prop {
  modelValue: boolean;
}

const props = defineProps<Prop>();

interface Emits {
  (e: "update:modelValue", newValue: boolean): void;
}
const emit = defineEmits<Emits>();

const value = ref(props.modelValue);

const click = () => {
  value.value = !value.value;
  emit("update:modelValue", value.value);
};

</script>

<template>
  <div class="toggle-button-wrapper">
    <button
      type="button"
      class="button toggle off"
      :class="{ selected: !value }"
      @click="click"
    >
      {{ t("tasks.incompleted") }}
    </button>
    <button
      type="button"
      class="button toggle on"
      :class="{ selected: value }"
      @click="click"
    >
      {{ t("tasks.completed") }}
    </button>
  </div>
</template>

<style scoped lang="scss">
@import "@/assets/sass/mixin.scss";

.toggle-button-wrapper {
  display: inline-block;
  padding: .25rem;
  background-color: #22405F;
}

.button {
  border: none;
  border-bottom: 1px solid transparent;
  min-width: 4rem;
  color: #fff;
  background-color: #22405F;
  @include dark-bordered-text();
  &.selected {
    border-bottom-color: #37ffff;
  }
}

@include mq(sp) {
  .toggle-button-wrapper {
    width: 100%;
    display: flex;
    .button {
      flex: 1;
    }
  }
}

</style>
